module.exports = __webpack_public_path__ + "static/img/40019 (3).b7abea5.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40019 (3).webp
// module id = 5AaX
// module chunks = 14